export default __webpack_public_path__ + "media/images/flags@2x-1ff49fd4eddddb2bde9f78c2434bb12e.png";